export function ZeroMethod(argument: unknown): argument is 0 {
  return argument === 0;
}
